import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {ReportGeneratorService} from '../../../services/report-generator.service';
import {ApiClientService} from '../../../services/api-client.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'report-generator-list',
    templateUrl: './report-generator-list.component.html',
    styleUrls: ['./report-generator-list.component.scss']
})
export class ReportGeneratorListComponent {

    constructor(
        public api: ApiClientService,
        public urlService: UrlService,
        public reportGeneratorService: ReportGeneratorService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.reportGeneratorService.data[this.reportGeneratorService.tabId].total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    openReport(report, format) {
        const url = report.links[format];

        window.open(url);
    }

    showHint(e) {
        const $td = $(e.target).closest('.report-generator-hint-td');
        if ($td.hasClass('active'))
            $td.removeClass('active');
        else {
            $('.report-generator-hint-td').removeClass('active');
            $td.addClass('active');
        }
    }

    openCustomViewReport(report) {
        this.reportGeneratorService.showCustomReportViewModal = true;
        this.reportGeneratorService.templateInTemplateModal = report;
    }

    openEditNameModal(report) {
        this.reportGeneratorService.showReportNameModal = true;
        this.reportGeneratorService.reportInReportModal = report;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/report-generator/report-generator-list/report-generator-list.component.ts